import { InboxIndex } from '@/features/inbox/InboxLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/inbox/')({
  component: InboxIndex,
});
